import { useDriverPushBootstrap } from "./usePushBootstrap.js";

export default function DriverPushBootstrap({ enabled = true }) {
  useDriverPushBootstrap({
    enabled,
    onAction: (action) => {
      console.log("[driver-push] action:", action);
    },
  });

  return null;
}
